export default "https://cdn-static.gokick.com/assets/4215e61f258b66d5599ee2c3a2c4c86e46d29fa2/images/diastolic-smaller.c0fadbcdc01bd506880e051915c30039.svg";